import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // Global base styles
import App from './App';
import './firebase'; // Initialize Firebase

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);